export default "<h2>Oops! You've landed on a page that doesn't exist or you do not have access rights to.</h2>\n<p>Redirecting in 5 seconds...</p>\n"